import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatSort, SortDirection } from '@angular/material/sort';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {
  filter,
  take,
  takeUntil,
} from 'rxjs';
import { Sale, SaleTypes } from 'src/app/models/sales/sales.model';
import { AuthService } from 'src/app/services/auth.service';
import { SalesService } from 'src/app/services/sales.service';
import { ActionListenerService } from 'src/app/shared-new/services/action-listener.service';
import { ToastService } from 'src/app/shared-new/services/toast.service';
import { SalesFacade } from 'src/app/shared-new/store/sales/sales.facade';
import { DateParserFormatter } from 'src/app/utils/helper/date-parser-formatter';
import Swal from 'sweetalert2';
import { NotificationAction, NotificationEvent, SaleRequestNotificationDto } from '../../models/common/notification-event.model';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { EventsEmitter } from '../../shared/event-emitter/EventEmitter';
import { DeadLinesPopupComponent } from '../dead-lines-popup/dead-lines-popup.component';
import { SaleGrantedComponent } from '../sale-granted/sale-granted.component';
import { SaleMemberRequestPopupComponent } from '../sale-member-request-popup/sale-member-request-popup.component';
import { SaleTermsConditionPopupComponent } from '../sale-terms-condition-popup/sale-terms-condition-popup.component';
import { SaleMediaConversionLogModalComponent } from '../sale-media-conversion-log-modal/sale-media-conversion-log-modal.component';
import { SaleIndexDataSource } from './sale-list-datasource';
@Component({
  selector: 'app-sale-list',
  templateUrl: './sale-list.component.html',
  styleUrls: ['./sale-list.component.scss'],
})
export class SaleListComponent
  extends BaseUnsubscribeComponent
  implements OnInit, OnDestroy, AfterViewInit {
  public sales: Sale[];
  public allSales: Sale[];
  public allSalesDataSource: SaleIndexDataSource;
  public currentSalesDataSource: SaleIndexDataSource;
  public futureSalesDataSource: SaleIndexDataSource;
  public pastSalesDataSource: SaleIndexDataSource;
  public searchTerm: string;
  public isLoader: boolean;
  tab: SaleTypes = null;
  sales$ = this.salesFacade.sales$;
  salesLoaded$ = this.salesFacade.salesLoaded$;
  salesListError$ = this.salesFacade.salesListError$;
  public SaleTypes = SaleTypes;
  public isSalesEditor: boolean = false;
  public dataSource: SaleIndexDataSource;
  public displayedColumns = [
    'saleImageUrl',
    'saleName',
    'saleHorseCount',
    'repositoryLocation',
    'accessionPrefix',
    //'dateRange',

    'startDate',
    'lodgeBefore',
    'viewStartDate',
    'sellingStartDate',
    'deadlines',
    //'accessionExample',
    'action',
  ];

  public closeResult = '';
  activeSaleId: number = null;
  isSalesCompany = false;
  term: string = '';

/*  @ViewChild('searchInput') public readonly searchInput: ElementRef;*/
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private readonly salesService: SalesService,
    private salesFacade: SalesFacade,
    private readonly modalService: NgbModal,
    private readonly router: Router,
    public readonly authService: AuthService,
    private httpErrorHandlerService: HttpErrorHandlerService,
    private readonly dateParserFormatter: DateParserFormatter,
    private toastService: ToastService,
    private actionListenerService: ActionListenerService,
    private changeDetectorRefs: ChangeDetectorRef,
    private readonly eventEmitter: EventsEmitter,
  ) {
    super();
    this.isSalesEditor = this.authService.GlobalMemberAccessData.isSalesEditor;
  }

  public ngOnInit(): void {
    this.isSalesCompany = this.authService.IsSalesCompany();
    this.loadSales();
    this.eventEmitter.onSaleRequestApproveOrDeniedEvent.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.loadSales(true);
    })
    this.eventEmitter.onSaleRequested.pipe(takeUntil(this.unsubscribe$)).subscribe((notification: NotificationEvent<SaleRequestNotificationDto>) => {
      
      if (notification.action === NotificationAction.Approved || notification.action === NotificationAction.Denied) {
        this.updateSaleFromNotification(notification);
      }
    });
  }

  private updateSaleFromNotification(
    notification: NotificationEvent<SaleRequestNotificationDto>
  ): void {

    const request = notification.data?.saleMemberRequest;
    if (!request) return;

    const sale = this.allSales?.find(
      s => s.saleId === notification.scope.saleId
    );

    if (!sale) return;

    // surgical updates only
    sale.saleMemberStatusId = request.saleMemberStatusId;
    sale.deniedComments = request.comments ?? sale.deniedComments;

    // if terms / access flags change, update here too
    // sale.isViewDateApplicable = request.isViewDateApplicable;

    this.reInitCurrentDataSource();
  }

  private reInitCurrentDataSource(): void {
    if (!this.dataSource) return;

    const currentFilter = this.term;
    const currentTab = this.tab;

    // rebuild ONLY the active tab
    this.onSelectSales(currentTab, true);

    // restore filter
    if (currentFilter) {
      setTimeout(() => {
        this.dataSource.filter = currentFilter;
      });
    }

    this.changeDetectorRefs.detectChanges();
  }



  public ngAfterViewInit(): void {
    //fromEvent(this.searchInput.nativeElement, 'keyup')
    //  .pipe(
    //    debounceTime(50),
    //    distinctUntilChanged(),
    //    takeUntil(this.unsubscribe$),
    //    tap(() => {
    //      this.term = this.searchInput.nativeElement.value;
    //      this.dataSource.filter = this.term;
    //    })
    //  )
    //  .subscribe();

    //if (this.searchTerm) {
    //  this.searchInput.nativeElement.value = this.searchTerm;
    //  this.dataSource.filter = this.searchTerm;
    //}
  }
  filterSale(searchText: string) {
    this.searchTerm = searchText;
    this.dataSource.filter = searchText;
  }

  isTimeEqualsTo12AM(time: string): boolean {
    if (time === '12:00 AM') {
      return true;
    }
    return false;
  }
  openDeadLinePopup(sale: Sale) {
    this.salesService.getSaleDeadLine(sale.saleId).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      const modalRef = this.modalService.open(DeadLinesPopupComponent, {
        ariaLabelledBy: sale.saleId + 'Id',
        centered: true,
        size: 'xl',
        keyboard: false,
        backdrop: 'static',
      });

      modalRef.componentInstance.sale = response;
      modalRef.result.then(
        (result) => {
          const data = JSON.parse(result);
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
    })
  }
  openSaleTermsConditionPopup(sale: Sale) {
    if (sale.isTermsAcceptanceRequired) {
      this.activeSaleId = sale.saleId;
      const modalRef = this.modalService.open(
        SaleTermsConditionPopupComponent,
        {
          ariaLabelledBy: sale.saleId + 'Id',
          centered: true,
          size: 'xl',
          keyboard: false,
          backdrop: 'static',
        }
      );

      modalRef.componentInstance.data = {
        saleId: sale.saleId,
        termsAndConditions: sale.termsUrl,
        privacyPolicy: sale.privacyUrl,
        studyHelp: sale.studyHelp,
        viewingHelp: sale.viewingHelp,
      };
      modalRef.result.then(
        () => {
          this.sales$
            .pipe(
              filter(
                (sales) =>
                  !sales.find((s) => s.saleId === this.activeSaleId)
                    ?.isTermsAcceptanceRequired
              ),
              take(1)
            )
            .subscribe(() => {
              this.router.navigate(['/sales/', sale.saleId]);
            });
          this.salesFacade.acceptTermsAndConditions(sale.saleId);
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
    } else {
      this.router.navigate(['/sales/', sale.saleId]);
    }
    return;
  }
  public sendSaleMemberRequest(sale: Sale) {
    const modalRef = this.modalService.open(SaleMemberRequestPopupComponent, {
      ariaLabelledBy: sale.saleId + 'Id',
      centered: true,
      size: '50-width',
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.componentInstance.data = {
      saleId: sale.saleId,
      isViewAccess: sale.isViewDateApplicable,
      isSubmitAccess: sale.isSubmitDateApplicable,
      isXrayDownloadAccess: true,
      isSubmitDateApplicable: sale.isSubmitDateApplicable,
      isViewDateApplicable: sale.isViewDateApplicable,
      isViewRequestAllowed: sale.isViewRequestAllowed,
      isSubmitRequestAllowed: sale.isSubmitRequestAllowed,
      comments: '',
    };
    modalRef.componentInstance.isDenied = false;
    modalRef.result.then(
      (result) => {
        const data = JSON.parse(result);
        this.salesService
          .sendSaleMemberRequestAccess(data)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (response) => {
              if (response) {
                this.toastService.success('Request has been sent successfully');
                //const currentLevel = this.dataSource.infiniteScrollLevel;
                this.loadSales(true);
                //this.dataSource = new SaleIndexDataSource(
                //  this.sales,
                //  this.sort,
                //  false,
                //  currentLevel
                //);
                //this.changeDetectorRefs.detectChanges();
                setTimeout(() => {
                  this.dataSource.filter = this.term;
                }, 1000);
              }
            },
            (err) => {
              if (err) {
                this.httpErrorHandlerService.ShowErrorMessage(err);
              }
            }
          );
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  public acceptSaleInvitation(sale: Sale) {
    const modalRef = this.modalService.open(SaleGrantedComponent, {
      ariaLabelledBy: sale.saleId + 'Id',
      centered: true,
      size: '50-width',
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.componentInstance.data = {
      saleMemberAccessId: sale.saleMemberAccessId,
    };
    modalRef.componentInstance.isDenied = false;
    modalRef.result.then(
      (result) => {
        const data = JSON.parse(result);
        this.router.navigate(['/sales/', data.saleId]);
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  public IsRequestAccess(sale: Sale): boolean {
    if (
      sale.saleMemberStatusId === 0 &&
      (sale.isViewDateApplicable || sale.isSubmitDateApplicable)
    ) {
      return true;
    }
    return false;
  }
  public viewComments(sale: Sale) {
    Swal.fire({
      title: sale.saleName,
      html: `${sale.deniedComments} <br/> <br/> <br/> If you have made changes based on the above feedback, you can request access to this sale again below`,
      showCancelButton: true,
      confirmButtonText: 'Request access',
      cancelButtonText: 'Close',
      reverseButtons: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.sendSaleMemberRequest(sale);
        Swal.close();
      } else {
        Swal.close();
      }
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  public loadSales(isLoadCurrentTab: boolean = false): void {
    this.salesFacade.loadSales();

    this.sales$.subscribe((sales) => {
      this.sales = sales.map(s => ({ ...s }));
      this.allSales = sales.map(s => ({ ...s }));
      this.activeTab(isLoadCurrentTab);
    });
  }

  public get currentSales() {
    return this.allSales
      .filter((sale) => sale.saleTimeFactor === SaleTypes.CURRENT)
      .sort((current, next) => {
        return moment(current.saleStartDate).isAfter(next.saleStartDate)
          ? -1
          : 1;
      });
  }

  public get futureSales() {
    return this.allSales
      .filter((sale) => sale.saleTimeFactor === SaleTypes.FUTURE)
      .sort((current, next) => {
        return moment(current.saleStartDate).isAfter(next.saleStartDate)
          ? -1
          : 1;
      });
  }

  public get pastSales() {
    return this.allSales
      .filter((sale) => sale.saleTimeFactor === SaleTypes.PAST)
      .sort((current, next) => {
        return moment(current.saleStartDate).isAfter(next.saleStartDate)
          ? -1
          : 1;
      });
  }

  public onSelectSales(saleType: SaleTypes = null, isLoadCurrentTab: boolean = false): void {
    const currentLevel = this.dataSource ? this.dataSource.infiniteScrollLevel : 20;
    if (saleType === SaleTypes.CURRENT) {
      if (!this.currentSalesDataSource || isLoadCurrentTab) {
        this.currentSalesDataSource = new SaleIndexDataSource(this.currentSales, this.sort, false, currentLevel);
      }
      if (isLoadCurrentTab) {
        this.futureSalesDataSource = null;
        this.pastSalesDataSource = null;
        this.allSalesDataSource = null;
      }
        this.dataSource = this.currentSalesDataSource;
        this.applyDefaultSort('sellingStartDate', 'asc');
    }
    else if (saleType === SaleTypes.FUTURE) {
      if (!this.futureSalesDataSource || isLoadCurrentTab) {
        this.futureSalesDataSource = new SaleIndexDataSource(this.futureSales, this.sort, false, currentLevel);
      }
      if (isLoadCurrentTab) {
        this.currentSalesDataSource = null;
        this.pastSalesDataSource = null;
        this.allSalesDataSource = null;
      }
      this.dataSource = this.futureSalesDataSource;
      this.applyDefaultSort('sellingStartDate', 'asc');
    } else if (saleType === SaleTypes.PAST) {
      if (!this.pastSalesDataSource || isLoadCurrentTab) {
        this.pastSalesDataSource = new SaleIndexDataSource(this.pastSales, this.sort,false,currentLevel);
      }
      if (isLoadCurrentTab) {
        this.futureSalesDataSource = null;
        this.currentSalesDataSource = null;
        this.allSalesDataSource = null;
      }
      this.dataSource = this.pastSalesDataSource;
      this.applyDefaultSort();
    } else {
      if (!this.allSalesDataSource || isLoadCurrentTab) {
        this.allSalesDataSource = new SaleIndexDataSource(this.allSales, this.sort, false, currentLevel);
      }
      if (isLoadCurrentTab) {
        this.futureSalesDataSource = null;
        this.currentSalesDataSource = null;
        this.pastSalesDataSource = null;
      }
      this.dataSource = this.allSalesDataSource;
      this.applyDefaultSort();
    }
   
    this.dataSource.sort = this.sort; // just in case
    this.tab = saleType;
  }

  private applyDefaultSort(sortActive: string = '', sortDirection: SortDirection = ''): void {
    this.dataSource.sort.active = sortActive;
    this.dataSource.sort.direction = sortDirection;
    this.sort.sortChange.emit(this.sort);
    this.changeDetectorRefs.detectChanges();
  }


  public getSaleDateFormat(sale: Sale) {
    return this.dateParserFormatter.getDateFormatForSale(sale, false);
  }

  public getSaleDateFormatWithTime(sale: Sale) {
    return this.dateParserFormatter.getDateFormatForSaleWithTime(sale, false);
  }

  public onTableScroll(): void {
    this.dataSource?.onScroll();
  }

  public activeTab(isLoadCurrentTab: boolean = false): void {
    if (isLoadCurrentTab) {

      this.onSelectSales(this.tab, isLoadCurrentTab);

    } else {
      if (this.currentSales.length > 0) {
        return this.onSelectSales(SaleTypes.CURRENT);
      }

      if (this.futureSales.length > 0) {
        return this.onSelectSales(SaleTypes.FUTURE);
      }
      if (this.currentSales.length == 0 && this.futureSales.length == 0 && this.allSales.length > 0) {
        return this.onSelectSales();
      }
    }
  }


  openMediaConversionLogModal(sale: Sale) {
    const modalRef = this.modalService.open(
      SaleMediaConversionLogModalComponent,
      {
        ariaLabelledBy: 'media-conversion-logs',
        centered: true,
        size: 'lg',
        keyboard: false,
        backdrop: 'static',
      }
    );

    modalRef.componentInstance.saleId = sale.saleId;
    modalRef.componentInstance.format = this.dateParserFormatter.getDateFormatForSaleWithTime(sale, false);
    modalRef.componentInstance.isLoader = true;
    this.salesService.getSaleMediaConversionLogs(sale.saleId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (logs) => {
          modalRef.componentInstance.conversionLogs = logs;
          modalRef.componentInstance.isLoader = false;
        },
        error: () => {
          modalRef.componentInstance.isLoader = false;
        }
      });
  }
}
